import styled from "styled-components";

export const HeaderText = styled.h1`
    margin: 10px;
    padding-top: 30px;
    padding-bottom: 10px;
`;